import { useCallback } from "react"

import { useMutation, useQuery } from "@tanstack/react-query"
import { AxiosError } from "axios"

import { axiosClient } from "$/http"

import Urls from "@/api/urls"
import { GoalsSortType } from "@/shared/types/sort"

import { QueryKey } from "../consts"
import { OldBelief, OldBeliefApi } from "../model/types/old-belief"

const getOldBelief = async ({ queryKey }): Promise<OldBeliefApi[]> => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [_key, { id, query }] = queryKey
    const { data } = await axiosClient.get(Urls.oldBelief(id, query))
    return data
}

export function useOldBeliefData(participantId: number, query: GoalsSortType) {
    return useQuery<OldBeliefApi[], AxiosError, OldBelief[]>({
        queryKey: [QueryKey.OldBelief, { query, id: participantId }],
        queryFn: getOldBelief,
        select: useCallback(data => data.map(item => new OldBelief(item)), [])
    })
}

export function useArchiveOldBeliefData(participantId: number) {
    return useQuery<OldBeliefApi[], AxiosError, number[]>({
        queryKey: [QueryKey.OldBelief, { query: "archived", id: participantId }],
        queryFn: getOldBelief,
        select: useCallback(data => data.map(item => item.id), [])
    })
}

export function useCreateOldBelief(participantId: number) {
    return useMutation({
        mutationFn: (oldBelief: Pick<OldBeliefApi, "description" | "order" | "title">) =>
            axiosClient.post<{ id: number }>(Urls.createOldBelief(participantId), oldBelief)
    })
}

export function useEditOldBelief(participantId: number) {
    return useMutation({
        mutationFn: (oldBelief: Pick<OldBeliefApi, "description" | "order" | "id" | "title">) => {
            const { id, ...data } = oldBelief
            return axiosClient.put(Urls.editOldBelief(participantId, id), data)
        }
    })
}

export function useArhiveOldBelief(participantId: number) {
    return useMutation({
        mutationFn: (oldBeliefId: number) => axiosClient.post(Urls.archiveOldBelief(participantId, oldBeliefId))
    })
}

export function useUnarciveOldBelief(participantId: number) {
    return useMutation({
        mutationFn: (oldBeliefId: number) => axiosClient.post(Urls.unarchiveOldBelief(participantId, oldBeliefId))
    })
}

export function useSortOldBelief(participantId: number) {
    return useMutation({
        mutationFn: (sort: { ids: number[] }) => axiosClient.post(Urls.sortOldBelief(participantId), sort)
    })
}
